module.exports = __webpack_public_path__ + "img/SmartGuide_mehrfarbig_RGB.e757217a.svg";